/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PreviousDamages } from './previousDamages';

/**
 * Represents a motor vehicle liability insurance.   (german: Kfz Haftpflicht)   (bipro-kraftfahrt::KfzHaftpflichtVersicherung)
 */
export interface PreviousMotorVehicleLiabilityInsurance {
  /**
   * Technical discriminator for the concrete elementary product type.
   */
  productType: string;
  damages?: PreviousDamages;
}
